<template>
  <ProgressBar v-if="loading" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>

  <div class="header border-bottom-1 border-200 z-3">
    <div class="color-text text-xl flex align-items-center">
      <Button @click="goBack" icon="pi pi-arrow-left" text rounded aria-label="Filter" severity="secondary" />
      <span class="ml-2 text-color">{{ titulo }}</span>
    </div>
    <div>
      <slot name="rigthmenu"></slot>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import Button from 'primevue/button';
import ProgressBar from 'primevue/progressbar';
import { defineProps } from 'vue';
const props = defineProps({
  titulo: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const router = useRouter();

function goBack() {
  router.go(-1);
}



</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  box-sizing: border-box;
  background-color: #fff;
}
</style>